import { Broadcast, ChartLineUp, MapPin, Pulse } from "@phosphor-icons/react";

export function MarketPulseCard({ data }) {
  if (!data?.enabled) return null;
  return (
    <section className="rounded-[28px] p-6 sm:p-7 mb-10 overflow-hidden relative" style={{ background: "linear-gradient(135deg, rgba(245,251,249,0.98) 0%, rgba(236,244,239,0.96) 100%)", border: "1px solid rgba(91,138,111,0.22)" }} data-testid="market-pulse-card">
      <div className="absolute -right-10 -top-10 w-36 h-36 rounded-full" style={{ background: "rgba(91,138,111,0.12)" }} />
      <div className="relative flex flex-wrap items-start justify-between gap-4">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold" style={{ background: "rgba(255,255,255,0.7)", color: "var(--bk-success)" }}>
            <Broadcast size={14} weight="duotone" /> Market Pulse
          </div>
          <h3 className="font-display text-2xl sm:text-3xl font-bold mt-3" style={{ color: "var(--bk-text)" }} data-testid="market-pulse-heading">{data.headline}</h3>
          <p className="text-sm mt-2 leading-relaxed" style={{ color: "var(--bk-text-2)" }} data-testid="market-pulse-rowan-primary">{data.rowan_primary}</p>
        </div>
        <div className="rounded-2xl px-4 py-3" style={{ background: "rgba(255,255,255,0.75)" }} data-testid="market-pulse-quality-indicator">
          <p className="text-xs uppercase tracking-[0.16em] font-semibold" style={{ color: "var(--bk-text-2)" }}>Data quality</p>
          <p className="text-sm mt-2 font-medium" style={{ color: "var(--bk-text)" }}>{data.data_quality}</p>
        </div>
      </div>

      <div className="relative grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-5 mt-6">
        <div className="bk-card p-5" data-testid="market-pulse-trends">
          <div className="flex items-center gap-2 mb-3">
            <Pulse size={18} weight="duotone" color="var(--bk-success)" />
            <p className="text-sm font-semibold" style={{ color: "var(--bk-text)" }}>Trend bullets</p>
          </div>
          <ul className="space-y-3 text-sm leading-relaxed" style={{ color: "var(--bk-text)" }}>
            {(data.trend_bullets || []).map((item, idx) => <li key={`${idx}-${item}`} data-testid={`market-pulse-bullet-${idx}`}>• {item}</li>)}
          </ul>
        </div>

        <div className="space-y-4">
          <div className="bk-card p-5" data-testid="market-pulse-region-card">
            <div className="flex items-center gap-2">
              <MapPin size={18} weight="duotone" color="var(--bk-accent)" />
              <p className="text-xs uppercase tracking-[0.16em] font-semibold" style={{ color: "var(--bk-text-2)" }}>Region</p>
            </div>
            <p className="font-display text-2xl font-bold mt-2" style={{ color: "var(--bk-text)" }}>{data.region_label}</p>
            <p className="text-xs mt-2" style={{ color: "var(--bk-text-2)" }}>{data.is_local_ready ? "Local trends are live." : "Using national fallback until more local owners opt in."}</p>
          </div>
          <div className="bk-card p-5" data-testid="market-pulse-voice-lines">
            <div className="flex items-center gap-2 mb-3">
              <ChartLineUp size={18} weight="duotone" color="var(--bk-accent)" />
              <p className="text-sm font-semibold" style={{ color: "var(--bk-text)" }}>Rowan voice lines</p>
            </div>
            <ul className="space-y-2 text-sm" style={{ color: "var(--bk-text-2)" }}>
              {(data.rowan_voice_lines || []).map((line) => <li key={line}>• {line}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}